const Variants = {
  TopNav: "top-nav",
  TopNavInline: "top-nav-inline",
  SideNav: "side-nav",
} as const;
export const StandardNavLinkDropdownVariants = Variants;
export type StandardNavLinkDropdownVariant =
  (typeof Variants)[keyof typeof Variants];
